import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { environment } from 'src/environments/environment';
import { Subscription, SubscriptionDetails, CustomerSubscriptionAddOnItem, SettingsCustomerSubscription } from '../models/subscription.model';
import { NotificationScheduleOption } from "../../shared/models/settings/notification-schedule-option";

@Injectable({
    providedIn: "root"
})
export class SubscriptionService {
  private baseRoute: string;

  private mockSubscriptions: BehaviorSubject<Subscription[]>;
  private mockSubscriptionDetails: BehaviorSubject<SubscriptionDetails[]>;
  constructor(private httpClient: HttpClient) {
    this.mockSubscriptions = new BehaviorSubject<Subscription[]>([
      { SubscriptionNumber : '20201205000100001', InvoiceNumber : '20191205000100001', Customer : 'Wolfgang Paganini', Frequency : 'Monthly', DueDate : '12th of the Month', BalanceDue : 2000, Status : 'Acitve' },
      { SubscriptionNumber : '20201205000100002', InvoiceNumber : '20191205000100002', Customer : 'Johannes Baethoven', Frequency : 'Weekly', DueDate : '11/21/2020', BalanceDue : 1400.00, Status : 'Active' },
      { SubscriptionNumber : '20201205000100003', InvoiceNumber : '20191205000100003', Customer : 'Ray Mendelbach', Frequency : 'Bi-Monthly', DueDate : '3/01/2020', BalanceDue : 1250, Status : 'Active' },
    ]);

    this.mockSubscriptionDetails = new BehaviorSubject<SubscriptionDetails[]>([

    ])

  }

  //MOCK DATA
  getMockSubscriptions<T>(): Observable<Subscription[]>{
    return this.mockSubscriptions.asObservable();
  }

  getMockSubscriptionItems<T>() : Observable<SubscriptionDetails[]>{
    return this.mockSubscriptionDetails.asObservable();
  }

  addMockSubscriptionItem(subscriptionDetails: SubscriptionDetails){
    let items = this.mockSubscriptionDetails.getValue();
    items.push(subscriptionDetails);
    this.mockSubscriptionDetails.next(items);
  }

  getSubscriptions<T>() : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getall`);
  }

  getSubscription<T>(id: number) : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/get/${id}`);
  }

  addCustomerSubscription<T>(payload: any): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/add`, payload);  }

  updateCustomerSubscription<T>(payload: any): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/update`, payload);
  }

  paySubscriptionInitially<T>(id: number, userId: number): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/paysubscriptioninitially/${id}/${userId}`, null);  }

  getCustomerSubscriptionPayments<T>(id: number) : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getsubscriptionpayments/${id}`);
  }

  upsertSubscriptionConfiguration<T>(payload: any): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/upsertconfiguration`, payload);
  }

  getConfigurationBySubscriptionId<T>(id: number) : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getconfiguration/${id}`);
  }


  cancelSubscription<T>(payload: any): Observable<T> {
    return this.httpClient.put<T>(`${environment.customerAPIRoot}/customersubscription/cancel`, payload);
  }

  pauseSubscription<T>(payload: any): Observable<T> {
    return this.httpClient.put<T>(`${environment.customerAPIRoot}/customersubscription/pause`, payload);
  }

  resumeSubscription<T>(payload: any): Observable<T> {
    return this.httpClient.put<T>(`${environment.customerAPIRoot}/customersubscription/resume`, payload);
  }

  deleteCustomerSubscription<T>(id: number, userId: number): Observable<T> {
    return this.httpClient.delete<T>(`${environment.customerAPIRoot}/customersubscription/delete/${id}/${userId}`);
  }

  sendRequestPaymentEmail<T>(id: number): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/sendrequestpaymentemail/${id}`, null);
  }

  approveSubscription<T>(subscriptionId: number, userid: number): Observable<T> {
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/approvesubscription/${subscriptionId}/${userid}`, null);
  }

  getCustomerSubscriptionCancellations<T>() : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getcustomersubscriptioncancellations`);
  }




  //Plan Addons
  getAddOnItemBySubscriptionId<T>(planId: number): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getaddonitembysubscriptionid/${planId}`);
  }

  getAddOnItemById<T>(id: number): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getaddonitembyid/${id}`);
  }

  upsertAddOnItem<T>(payload: CustomerSubscriptionAddOnItem): Observable<T>{
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/upsertaddonitem`, payload);
  }

  upsertAddOnItems<T>(payload: CustomerSubscriptionAddOnItem[]): Observable<T>{
    return this.httpClient.post<T>(`${environment.customerAPIRoot}/customersubscription/upsertaddonitems`, payload);
  }

  deletePlanAddOnItem<T>(id: number, userId: number): Observable<T>{
    return this.httpClient.delete<T>(`${environment.customerAPIRoot}/customersubscription/deleteaddonitem/${id}/${userId}`);
  }

  approveCustomerSubscriptionCancellationRequest(id: number, userId: number){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/approvesubscriptioncancellationrequest/${id}/${userId}`,null);
  }

  getCancellationReasons<T>() : Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getcancellationreasons`);
  }

  upsertCustomerSubscriptionCancellationReason(payload: any){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/upsertcustomersubscriptioncancellationreason`,payload);
  }

  deleteCustomerSubscriptionCancellationReason(id: number, userId: number){
    return this.httpClient.delete(`${environment.customerAPIRoot}/customersubscription/customersubscriptioncancellationreason/${id}/${userId}`);
  }

  getEndDateByRule(payload: any){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/getEndDateByRule`,payload);
  }

  getNextDueDateByRule(payload: any){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/getnextduedatebyrule`,payload);
  }

  getNextDueDate(payload: any){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/getnextduedate`,payload);
  }

  getNextDueDateByRuleBySubscriptionId(frequencyRule: any, subscriptionId){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/getnextduedatebyrulebysubscriptionid/${subscriptionId}`,frequencyRule);
  }


  suspendSubscription(payload: any){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/suspendsubscription`,payload);
  }

  getSubscriptionSuspensionsBySubscriptionId<T>(id: number): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getsubscriptionsuspensionsbysubscriptionid/${id}`);
  }

  getUnpaidInvoice<T>(id: number): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getunpaidinvoice/${id}`);
  }

  getAllCancellationsForApproval<T>(): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getallcancellationsforapproval`);
  }

  getGeneralSettings<T>(): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getgeneralsettings`);
  }

  updateGeneralSettings(payload: SettingsCustomerSubscription){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/updategeneralsettings`,payload);
  }

  getactivenotificationscheduleoption<T>(moduleType: string): Observable<T>{
    return this.httpClient.get<T>(`${environment.customerAPIRoot}/customersubscription/getactivenotificationscheduleoption/${moduleType}`);
  }

  upsertNotificationScheduleOption(payload: NotificationScheduleOption){
    return this.httpClient.post(`${environment.customerAPIRoot}/customersubscription/upsertnotificationscheduleoption`,payload);
  }



  /**removeMockSubscriptionItem<T>(itemId: number) {
    let items = this.mockSubscriptionItems.getValue();
    let filtered = items.filter((item) => {
      return item.ItemId !== itemId;
    });
    this.mockSubscriptionItems.next(filtered);
  }

  clearAllMockSubscriptionItems() {
    this.mockSubscriptionItems.next([]);
  }

  //peggy-backing this here for now since we only have this one api call for creditservice
  creditCharge<T>(payload: CreditPayment, userId: string, locationId: string, branchName: string ): Observable<T>{
    return this.httpClient.post<T>(`${environment.paymentAPIRoot}/api/credit/charge?userId=${userId}&locationId=${locationId}&branchName=${branchName}`, payload);
  }

  creditVerify<T>(payload: CreditPayment): Observable<T>{
    return this.httpClient.post<T>(`${environment.paymentAPIRoot}/api/credit/verify`, payload);
  }

  getPaidSubscriptionBySubscriptionNumber<T>(subscriptionId: string) : Observable<T>{
    return this.httpClient.get<T>(`${environment.subscriptionAPIRoot}/getpaidsubscriptionbysubscriptionnumber/${subscriptionId}`);
  }**/
}
